"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSpinner = createSpinner;
var _litHtml = require("lit-html");
function createSpinner() {
  return (0, _litHtml.html)`
    <span class="loading-spinner" aria-hidden="true"></span>
    <span class="sr-only">Saving...</span>
  `;
}